import { NotFound } from '@pages/NotFound';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';

const asyncComponent = (importFunc: () => Promise<{ default: React.ComponentType }>) => {
  const Component = lazy(importFunc);
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <Component />
    </Suspense>
  );
};

const routes: RouteObject[] = [
  {
    path: '/login/*',
    element: asyncComponent(() => import('@pages/Auth/LoginRoute')),
  },
  {
    path: '/permissionDenied',
    element: asyncComponent(() => import('@pages/PermissionPage')),
  },
  {
    path: '/tagPrint/*',
    element: asyncComponent(() => import('@pages/TagList/TagPrintPage')),
    handle: { breadcrumb: 'TagPrint' },
  },
  {
    path: '/tagPage/*',
    element: asyncComponent(() => import('@pages/TagList/TagPrintPage')),
    handle: { breadcrumb: 'TagPrint' },
  },
  {
    path: '/',
    element: asyncComponent(() => import('@pages/RootPage')),
    errorElement: <NotFound />,
    handle: { requiresAuth: true },
    children: [
      { index: true, element: asyncComponent(() => import('@pages/TagList/TagListPage')) },
      {
        path: 'lost-items',
        element: asyncComponent(() => import('@pages/LostItems/LostItemsPage')),
        handle: { breadcrumb: 'Lost Items' },
      },
      {
        path: 'users/*',
        element: asyncComponent(() => import('@pages/HotelUser/HotelUserPage')),
        handle: { breadcrumb: 'Users' },
      },
      {
        path: 'permissions/*',
        element: asyncComponent(() => import('@pages/Permission/PermissionManagePage')),
        handle: { breadcrumb: 'Permissions' },
      },
      {
        path: 'platform/hotels/*',
        element: asyncComponent(() => import('@pages/Platform/Hotel/HotelManagePage')),
        handle: { breadcrumb: 'Hotels' },
      },
      {
        path: 'platform/h-tag-bindings/*',
        element: asyncComponent(
          () => import('@pages/Platform/HotelTagBinding/HotelTagBindingManagePage'),
        ),
        handle: { breadcrumb: 'H Tag Bindings' },
      },
      {
        path: 'platform/courier-companies/*',
        element: asyncComponent(
          () => import('@pages/Platform/CourierCompanies/CourierCompaniesManagePage'),
        ),
        handle: { breadcrumb: 'Courier Companies' },
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
